import { Grid, Button, Input, FormControl, InputLabel, Select, MenuItem, TextField } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useStyles } from './styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloseIcon from '@material-ui/icons/Close';
import { InvitationFormProps } from '../../types';
import { useMutation, useQuery } from 'react-query';
import { useStore } from 'hooks/useRootStore';
import { InviteUsersCSV } from '../types';
import headerlogo from '../../../../../assets/icons/logo.svg';
import { useAppPreloader } from 'hooks/useAppPreloader';
import EmailHeader from 'components/EmailHeader/EmailHeader';
import { handleSampleDownload } from 'utils/urlUtils';
export const CsvFile: FC<InvitationFormProps> = ({ step, open, refetch, handleClose, emailtemps }) => {
  const classes = useStyles();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const handleFileChange = (e: any) => {
    setSelectedFile(e.target.files ? e.target.files[0] : null);
    setIsFilePicked(true);
  };
  const handleDragOver = (e: any) => {
    e.preventDefault();
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setSelectedFile(file);
    setIsFilePicked(true);
  };
  const [registrationStep, setRegistrationStep] = useState(true);
  const {
    invitationStore: { sendCSVInvitation, sendManualInvitationStepone },
    emailTemplatesTableStore: { getEmail, emailtemp },
    notificationStore: { openNotification },
    userStore: { user },
    appPreloaderStore: { disablePreloader },
  } = useStore();
  step(registrationStep);
  const sendCSVInvitationReq = useMutation((data: any) => sendCSVInvitation(data), {
    mutationKey: 'sendCSVInvitationReq',
    onSuccess: (e) => {
      disablePreloader();
      openNotification('success', `${e}`);
      refetch();
      reset();
      emailtemps(false);
      handleClose();
      disablePreloader();
    },
    onError: (e) => {
      disablePreloader();
      openNotification('error', `${e}`);
    },
  });
  const getEmailTemplateReq = useQuery('getEmailTemplateReq', () => getEmail(), {
    onError: () => {
      disablePreloader();
      openNotification('error', `Can't get upgrade license info`);
    },
  });
  const sendManualInvitationSteponeReq = useMutation((data: any) => sendManualInvitationStepone(data, 'CSV'), {
    mutationKey: 'sendManualInvitationSteponeReq',
    onSuccess: (e) => {
      setRegistrationStep(!registrationStep);
      emailtemps(registrationStep);
      disablePreloader();
      openNotification('success', `${e.message}`);
    },
    onError: (e) => {
      disablePreloader();
      openNotification('error', `${e}`);
    },
  });

  const [selected, setSelected] = useState<string>('register');
  const { control, handleSubmit, reset } = useForm<InviteUsersCSV>();

  const onSubmit = (data: InviteUsersCSV) => {
    const activeData =
      selected === 'register' ? { ...getEmailTemplateReq.data[0] } : { ...getEmailTemplateReq.data[1] };
    const pass = {
      users_file: selectedFile,
      inviteType: (data.inviteType = selected),
      ...activeData,
    };
    sendManualInvitationSteponeReq.mutate(pass);
  };
  const onSubmit2 = (data: InviteUsersCSV) => {
    const pass = {
      users_file: sendManualInvitationSteponeReq.data?.data?.users_file || '',
      inviteType: selected,
      templateSubject: selected === 'register' ? data.templateSubjectReg : data.templateSubjectPass,
      templateBody: selected === 'register' ? data.templateBodyReg : data.templateBodyPass,
      templateButton: selected === 'register' ? data.templateButtonReg : data.templateButtonPass,
      templateSignatureName: selected === 'register' ? data.templateSignatureNameReg : data.templateSignatureNamePass,
      templateSignaturePosition:
        selected === 'register' ? data.templateSignaturePositionReg : data.templateSignaturePositionPass,
    };
    sendCSVInvitationReq.mutate(pass);
  };
  useAppPreloader(getEmailTemplateReq.isLoading || sendCSVInvitationReq.isLoading);

  return (
    <>
      {registrationStep === true && (
        <form onSubmit={handleSubmit(onSubmit)} encType='multipart/form-data'>
          <Controller
            name='inviteType'
            defaultValue='register'
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <Grid className={classes.row} container>
                <FormControl className={classes.input}>
                  <InputLabel>Invitation type :</InputLabel>
                  <Select
                    {...field}
                    error={invalid}
                    value={selected}
                    className={classes.input}
                    onChange={(e: any) => setSelected(e.target.value)}
                    defaultValue={selected}
                  >
                    <MenuItem value='register'>New Account Registration</MenuItem>
                    <MenuItem value='password'>Update Password</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
          />
          <div className={classes.selectOption} onDragOver={handleDragOver} onDrop={handleDrop}>
            <Grid className={classes.filerow} container justify='space-between'>
              <div className={classes.textFileField}>
                <label style={{ cursor: 'pointer' }} htmlFor='file'>
                  <div>
                    <CloudUploadIcon className={classes.uploadIcon} />
                  </div>
                  <div className={classes.uploadtext}>
                    Drag your file here or <span>browse for files</span>
                  </div>
                </label>
              </div>
              <Controller
                render={({ field, fieldState: { invalid } }) => (
                  <Input
                    {...field}
                    className={classes.textField}
                    rows={4}
                    type='file'
                    error={invalid}
                    style={{ display: 'none' }}
                    id='file'
                    onChange={handleFileChange}
                  />
                )}
                control={control}
                name='users_file'
              />
              <Grid container justify='space-between' className={classes.fileInfo}>
                {isFilePicked ? (
                  <>
                    <Grid item xs={8}>
                      <p className={classes.fileadjust}>
                        <span className={classes.filename}>{selectedFile?.name}</span>
                        <span className={classes.filesize}> ({selectedFile?.size} kb)</span>
                      </p>
                    </Grid>
                    <Grid item xs={4} className={classes.fileicon}>
                      <Button
                        onClick={() => {
                          setSelectedFile(null);
                          setIsFilePicked(false);
                        }}
                        className={classes.space}
                      >
                        <CloseIcon className={classes.fileiconbtn} />
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12}>
                    <p>
                      <span className={classes.nofilename}>No file selected</span>
                    </p>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </div>
          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn}>
            <Grid className={classes.block}>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    handleSampleDownload(process.env.REACT_APP_DOWN_CSV as string, 'csv');
                  }}
                  variant='contained'
                  color='secondary'
                >
                  Download CSV sample file
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    handleClose();
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn2}
                  type='submit'
                  fullWidth
                  variant='contained'
                  disabled={!isFilePicked}
                  color='secondary'
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}

      {registrationStep === false && (
        <form onSubmit={handleSubmit(onSubmit2)} className={classes.formContainer}>
          <Grid>
            <Grid container xs={12} className={classes.emailHeader}>
              <img src={headerlogo} alt='' />
            </Grid>
            <Grid className={classes.labels}>
              <p>Hello!</p>
            </Grid>
            {getEmailTemplateReq.isLoading && (
              <Grid className={classes.details}>
                <Controller
                  key='1'
                  name='templateSubjectReg'
                  control={control}
                  defaultValue='I am inviting you to create a new user password at:'
                  rules={{ required: false }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        {...field}
                        error={invalid}
                        placeholder='I am inviting you to create a new user password at:'
                        defaultValue='I am inviting you to create a new user password at:'
                        helperText={invalid ? 'Required field' : ''}
                        className={classes.input}
                        multiline
                        rows={2}
                        InputProps={{ disableUnderline: true }}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )}
            <Grid className={classes.details}>
              {emailtemp.map((mail) => (
                <>
                  {selected === 'register' && mail.template === 'register' && (
                    <Controller
                      key='1'
                      name='templateSubjectReg'
                      control={control}
                      defaultValue={mail.templateSubject ?? undefined}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='I am inviting you to create a new user password at:'
                            defaultValue={mail.templateSubject ?? undefined}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            multiline
                            rows={2}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}
                </>
              ))}

              {emailtemp.map((mail) => (
                <>
                  {selected === 'password' && mail.template === 'password' && (
                    <Controller
                      key='1'
                      defaultValue={mail.templateSubject ?? undefined}
                      name='templateSubjectPass'
                      control={control}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='I am inviting you to create a new user password at:'
                            defaultValue={mail.templateSubject ?? undefined}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            multiline
                            rows={2}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}
                </>
              ))}

              <p>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateBodyReg'
                    defaultValue='I am inviting you'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='I am inviting you'
                          defaultValue='I am inviting you'
                          helperText={invalid ? 'Required field' : ''}
                          className={classes.input}
                          multiline
                          rows={2}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}
                {emailtemp.map((mail) => (
                  <>
                    {selected === 'register' && mail.template === 'register' && (
                      <Controller
                        key='1'
                        name='templateBodyReg'
                        defaultValue={mail.templateBody ?? undefined}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder='I am inviting you to create a new user password at:'
                              defaultValue={mail.templateBody ?? undefined}
                              helperText={invalid ? 'Required field' : ''}
                              className={classes.input}
                              multiline
                              rows={2}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}

                {emailtemp.map((mail) => (
                  <>
                    {selected === 'password' && mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateBodyPass'
                        defaultValue={mail.templateBody ?? undefined}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder='I am inviting you to create a new user password at:'
                              defaultValue={mail.templateBody ?? undefined}
                              helperText={invalid ? 'Required field' : ''}
                              className={classes.input}
                              multiline
                              rows={2}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
            </Grid>
            <Grid className={classes.emailbtn}>
              <Grid item xs={6} container className={classes.btndetails}>
                <Button fullWidth variant='contained' color='primary'>
                  {getEmailTemplateReq.isLoading && (
                    <Controller
                      key='1'
                      name='templateButtonReg'
                      defaultValue='Create an account'
                      control={control}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container className={classes.btn1}>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='Create an account'
                            defaultValue='Create an account'
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}
                  {emailtemp.map((mail) => (
                    <>
                      {selected === 'register' && mail.template === 'register' && (
                        <Controller
                          key='1'
                          name='templateButtonReg'
                          defaultValue='Create an account'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.btn1}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Create an account'
                                defaultValue='Create an account'
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      )}
                    </>
                  ))}
                  {emailtemp.map((mail) => (
                    <>
                      {selected === 'password' && mail.template === 'password' && (
                        <Controller
                          key='1'
                          name='templateButtonPass'
                          defaultValue='Update Password'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.btn1}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Update Password'
                                defaultValue='Update Password'
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      )}
                    </>
                  ))}
                </Button>
              </Grid>
            </Grid>
            <Grid className={classes.system}>
              <p className={classes.thanks}>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateSignatureNameReg'
                    defaultValue='Thanks, Yev Ledenov!'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.thanks}>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='Thanks, Yev Ledenov!'
                          defaultValue='Thanks, Yev Ledenov!'
                          helperText={invalid ? 'Required field' : ''}
                          className={`${classes.input} `}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}
                {emailtemp.map((mail) => (
                  <>
                    {selected === 'register' && mail.template === 'register' && (
                      <Controller
                        key='1'
                        name='templateSignatureNameReg'
                        defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.thanks}>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder={`Thanks, ${user?.name} ${user?.lastName}`}
                              defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                              helperText={invalid ? 'Required field' : ''}
                              className={`${classes.input} `}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}

                {emailtemp.map((mail) => (
                  <>
                    {selected === 'password' && mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateSignatureNamePass'
                        defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.thanks}>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder={`Thanks, ${user?.name} ${user?.lastName}`}
                              defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                              helperText={invalid ? 'Required field' : ''}
                              className={`${classes.input} `}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
              <p>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateSignaturePositionPass'
                    defaultValue=' System Administrator'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.admin}>
                        <TextField
                          {...field}
                          placeholder=' System Administrator'
                          defaultValue=' System Administrator'
                          helperText={invalid ? 'Required field' : ''}
                          className={` ${classes.input}`}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}
                {emailtemp.map((mail) => (
                  <>
                    {selected === 'password' && mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateSignaturePositionPass'
                        defaultValue={user?.permission}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.admin}>
                            <TextField
                              {...field}
                              placeholder={user?.permission}
                              defaultValue={user?.permission}
                              helperText={invalid ? 'Required field' : ''}
                              className={` ${classes.input}`}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}

                {emailtemp.map((mail) => (
                  <>
                    {selected === 'register' && mail.template === 'register' && (
                      <Controller
                        key='1'
                        name='templateSignaturePositionReg'
                        defaultValue={user?.permission}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.admin}>
                            <TextField
                              {...field}
                              placeholder={user?.permission}
                              defaultValue={user?.permission}
                              helperText={invalid ? 'Required field' : ''}
                              className={` ${classes.input}`}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
            </Grid>
            <EmailHeader
              ImageUrl={emailtemp[0].templateProfileImageUrl ?? ''}
              EmailUrl={emailtemp[0].templateAdminEmail ?? ''}
              OrganizationName={emailtemp[0].templateOrganizationName ?? ''}
            />
          </Grid>
          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn1}>
            <Grid className={classes.block} container>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    setRegistrationStep(!registrationStep);
                    emailtemps(registrationStep);
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button className={classes.btn2} type='submit' fullWidth variant='contained' color='secondary'>
                  Confirm & send invite
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};
